module.exports = __webpack_public_path__ + "img/01_uk.f740dce1.svg";